{
  "aviosLinkingAndExchange": {
    "loadingText": "Lataamme linkitettyjä tilejä",
    "moreAccounts": "Katso kaikki tilit avios.comissa"
  }
}
